export const environment = {
  production: false,
  // serverUrl: 'http://localhost:3000'
  serverUrl: 'https://api.welaenglish.co.kr'
};
